import { Box, Divider, Typography, SxProps } from '@mui/material';
import { NavTabs } from 'common/ui';
import { Paths } from 'services/navigation/paths';
import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { useIsOrganizationGroupAdmin } from 'hooks/useIsOrganizationGroupAdmin';
import {
  layoutContainerPaddingBottom,
  layoutContainerPaddingTop,
  layoutContainerPaddingX
} from 'services/navigation/components/PrivateRoute';

const container: SxProps = {
  pt: layoutContainerPaddingTop,
  pb: layoutContainerPaddingBottom,
  px: layoutContainerPaddingX
};

const headerContainer: SxProps = {
  display: 'flex',
  gap: 2,
  flexDirection: 'column',
  mb: 2
};

const dividerSx: SxProps = {
  my: 5
};

const tabs = [
  { label: 'Contract Dashboard', href: Paths.ADMINISTRATOR },
  { label: 'Accounts Overview', href: Paths.ADMINISTRATOR_ACCOUNTS_OVERVIEW }
];

export const AdministratorLayout: React.FC<PropsWithChildren> = ({
  children
}) => {
  const isOrganizationGroupAdmin = useIsOrganizationGroupAdmin();

  if (!isOrganizationGroupAdmin) {
    return <Navigate to={Paths.HOME} replace />;
  }

  return (
    <Box sx={container}>
      <Box sx={headerContainer}>
        <Typography variant="h3" fontWeight="bold" mt={2}>
          Administrator view
        </Typography>
        <Typography variant="body2">
          Manage usage, integrations and team members across all your sub
          accounts
        </Typography>
      </Box>
      <NavTabs tabs={tabs} />
      <Divider sx={dividerSx} />
      {children}
    </Box>
  );
};
